import React from 'react';
import PropTypes from 'prop-types';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import Options from 'components/form/managed_input/options';

const OfficeAssignees = ({ offices, officeAssigneeIds, setOfficeAssigneeIds, users }) => {
  if (!offices || offices.length <= 1) {
    return null;
  }

  const getUsersForOffice = (officeId) => {
    const BLANK_OPTION = { label: 'None', value: '' };
    const officeUsers = users.filter(user => user.officeId === officeId);
    
    return [BLANK_OPTION, ...officeUsers];
  };

  return (
    <>
      {offices.map(office => (
        <ManagedFormGroup
          key={office.id}
          label={office.name}
          type="select"
          value={officeAssigneeIds[office.id] || ''}
          onValueChange={userId => setOfficeAssigneeIds({
            ...officeAssigneeIds,
            [office.id]: userId
          })}
        >
          <Options options={getUsersForOffice(office.id)} />
        </ManagedFormGroup>
      ))}
    </>
  );
};

OfficeAssignees.propTypes = {
  officeAssigneeIds: PropTypes.object.isRequired,
  offices: PropTypes.array.isRequired,
  setOfficeAssigneeIds: PropTypes.func.isRequired,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      officeId: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default OfficeAssignees;
